import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { CopyrightConstant } from '../../../../Constants/CopyRightConstants';
import { images } from '../../../../Constants/ImageUrls';
import { removeDefaultParams } from '../../../../Utils/helper';
import { CopyRights, Icons, PrivacyPolicy, SocialSection } from './styled';

export default function SocialIcon() {
  const router = useRouter();
  const getParamRedirect = (url) => {
    return url;
    // if (window.location.search) {
    //     return url + "&" + getRedirectionParams();
    // } else {
    //     return url + "?" + getRedirectionParams();
    // }
  };
  const customObj = {
    utm_source: 'mylowebsite',
    utm_medium: 'footer',
    utem_campaign: router.asPath,
  };
  // const getRedirectionParams = () => {
  //     let path = `utm_source=mylowebsite&utm_medium=footer&utm_campaign=${window.location.pathname}`;
  //     return path;
  // };
  return (
    <SocialSection>
      <Icons>
        {/* <LazyLoad height={100} once offset={100}> */}
        <Link
          href={{
            pathname: getParamRedirect('https://www.instagram.com/mylofamily/'),
            query: removeDefaultParams({
              ...router.query,
              ...customObj,
            }),
          }}
          target="_blank"
        >
          <Image
            src={images.Insta}
            alt="instagram"
            loading="lazy"
            title="instagram"
            height={32}
            width={32}
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </Link>
        <Link
          href={{
            pathname: getParamRedirect('https://www.facebook.com/mylofamily'),
            query: removeDefaultParams({
              ...router.query,
              ...customObj,
            }),
          }}
          target="_blank"
        >
          <Image
            src={images.Fb}
            alt="facebook"
            title="facebook"
            loading="lazy"
            height={32}
            width={32}
          />
        </Link>
        <Link
          href={{
            pathname: getParamRedirect(
              'https://www.youtube.com/channel/UCP6udSSaBIJ-MFqMNtDNdWw',
            ),
            query: removeDefaultParams({
              ...router.query,
              ...customObj,
            }),
          }}
          target="_blank"
        >
          {' '}
          <Image
            src={images.Youtube}
            loading="lazy"
            alt="youtube"
            title="youtube"
            height={32}
            width={32}
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </Link>
        <Link
          href={{
            pathname: getParamRedirect(
              'https://www.linkedin.com/company/mylofamily/',
            ),
            query: removeDefaultParams({
              ...router.query,
              ...customObj,
            }),
          }}
          target="_blank"
        >
          <Image
            src={images.LinkedIn}
            alt="linkedin"
            loading="lazy"
            title="linkedin"
            height={32}
            width={32}
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </Link>
        {/* </LazyLoad> */}
      </Icons>
      <PrivacyPolicy>
        <Link
          href={{
            pathname: `/terms-of-use`,
            query: removeDefaultParams(router.query),
          }}
        >
          <span>TERMS OF USE</span>
        </Link>{' '}
        |{' '}
        <Link
          href={{
            pathname: `/privacy-policy`,
            query: removeDefaultParams(router.query),
          }}
        >
          <span>PRIVACY POLICY</span>
        </Link>{' '}
        |{' '}
        <Link
          href={{
            pathname: `/refund-cancellation`,
            query: removeDefaultParams(router.query),
          }}
        >
          <span>RETURN POLICY</span>
        </Link>{' '}
        |{' '}
        {/* <Link
                    href={{
                        pathname: "/my-orders",
                        query: removeDefaultParams(router.query),
                    }}
                    passHref
                >
                    <a> */}
        <span
          onClick={() =>
            (window.location.href = 'https://mylofamily.com/my-orders')
          }
        >
          TRACK ORDER
        </span>
        {/* </a>
                </Link> */}
      </PrivacyPolicy>
      <CopyRights>
        {CopyrightConstant.mainLine}
        {CopyrightConstant.date}
      </CopyRights>
    </SocialSection>
  );
}
